import React from "react";
import { Navigate } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import * as actions from "../../redux/actions/index";

import ScaleLoader from "react-spinners/ScaleLoader";
import { FormControl, TextField, Button } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) =>
  createStyles({
    formControl: {
      marginBottom: "1.5rem",
    },
    inputs: {
      fontSize: "1.2rem !important",
    },
    label: {
      fontSize: "1.1rem !important",
    },
    button: {
      height: "3.5rem",
      fontSize: "1.5rem",
      fontFamily: "Open Sans', sans-serif",
    },
  })
);

const Login = () => {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const authLoading = useSelector(
    (state) => state.cmsAuthenticator.authLoading
  );
  const auth = useSelector((state) => state.cmsAuthenticator.cmsAuth);
  const classes = useStyles();
  const dispatch = useDispatch();

  const onSubmit = (data) => {
    const credentials = JSON.stringify({
      username: data.username,
      password: data.password,
    });
    dispatch(actions.onCmsAuth(credentials));
  };

  const authLoader = <ScaleLoader style={{alignItems: 'center'}}/>;

  const redirect = auth ? <Navigate to="/dashboard" /> : null;

  return (
    <div className="Login">
      {redirect}
      <div className="Login__form-container">
        <div className="Login__illustration"></div>
        <div className="Login__form--container">
          <h4 className="Login__form--heading">Welcome to NutriAsia CMS</h4>
          {authLoading ? (
            authLoader
          ) : (
            <form onSubmit={handleSubmit(onSubmit)} className="Login__form">
              <FormControl className={classes.formControl} >
                <Controller
                  control={control}
                  name="username"
                  rules={{ required: true }}
                  className={classes.inputs}
                  render={({ field }) => (
                    <TextField
                    fullWidth
                      {...field}
                      type="text"
                      placeholder="username"
                      label="username"
                      InputProps={{
                        className: "Login__form--input",
                        classes: { input: classes.inputs },
                      }}
                      InputLabelProps={{ classes: { root: classes.label } }}
                    />
                  )}
                />
              </FormControl>
              <FormControl className={classes.formControl} >
                <Controller
                  control={control}
                  name="password"
                  type="password"
                  className={classes.inputs}
                  render={({ field }) => (
                    <TextField
                    fullWidth
                      {...field}
                      type="password"
                      placeholder="password"
                      label="password"
                      InputProps={{
                        className: "Login__form--input",
                        classes: { input: classes.inputs },
                      }}
                      InputLabelProps={{ classes: { root: classes.label } }}
                    />
                  )}
                />
              </FormControl>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                className={classes.button}
              >
                LOG IN
              </Button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default Login;
